/*
data-toggler:                   Add this attribute to the button, that toggles the content. Default Content is next sibling element according to the button.
                                Mandatory!
data-toggler="foo":             add an ID of the element to be toggled.
                                Optional!
data-toggler-o:                 Set this attribute to show overlay class in <body>.
                                Optional!
data-toggler-o="foo bar":       list of classes to toggle in <body>.
                                Default is class "body-overlay".
                                Optional!
data-toggler-cls="foo bar ":    list of css classes to be toggled on the target element.
                                Default is class "hidden".
                                Optional!
data-toggler-btn-cls="foo bar ":list of css classes to be toggled on the button.
                                Optional!
close-on-outside:              close this toggler when clicking outside button and target.
                                Optional! Use as boolean attribute: data-toggler-close-outside
reset-media="(max-width: ...)": reset this toggler when the media query changes its match state.
                                Optional! Example: data-toggler-reset-media="(max-width: 1023px)"
*/

const toggleBtns = document.querySelectorAll("[data-toggler]");

function splitClasses(value) {
    return (value || "")
        .split(" ")
        .filter(Boolean);
}

function getToggleElement(toggleBtn) {
    const id = toggleBtn.dataset.toggler;

    if (id === "") {
        return toggleBtn.nextElementSibling;
    }

    return document.getElementById(id);
}

function getToggleButtonsForId(id, fallbackBtn) {
    if (id === "") {
        return [fallbackBtn];
    }

    return Array.from(document.querySelectorAll(`[data-toggler="${id}"]`));
}

function resetSingleToggle(toggleBtn) {
    const id = toggleBtn.dataset.toggler;
    const toggleElement = getToggleElement(toggleBtn);
    const btnClasses = splitClasses(
        toggleBtn.getAttribute("data-toggler-btn-cls"),
    );
    const overlayClasses = splitClasses(toggleBtn.getAttribute("data-toggler-o"));
    const targetClasses = splitClasses(
        toggleBtn.getAttribute("data-toggler-cls"),
    );
    const relatedButtons = getToggleButtonsForId(id, toggleBtn);

    relatedButtons.forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        if (btnClasses.length) {
            btn.classList.remove(...btnClasses);
        }
    });

    if (toggleBtn.hasAttribute("data-toggler-o")) {
        if (overlayClasses.length) {
            document.body.classList.remove(...overlayClasses);
        } else {
            document.body.classList.remove("body-overlay");
        }
    }

    if (!toggleElement) {
        return;
    }

    if (targetClasses.length) {
        targetClasses.forEach((cl) => toggleElement.classList.remove(cl));
    } else {
        toggleElement.classList.add("hidden");
    }

    const defaultClasses = splitClasses(
        toggleElement.getAttribute("data-toggler-reset-default"),
    );
    const openClasses = splitClasses(
        toggleElement.getAttribute("data-toggler-reset-open"),
    );

    if (openClasses.length) {
        toggleElement.classList.remove(...openClasses);
    }
    if (defaultClasses.length) {
        toggleElement.classList.add(...defaultClasses);
    }
}

function resetToggleTargets(rootNode, selector) {
    if (!rootNode || !selector) {
        return;
    }

    rootNode.querySelectorAll(selector).forEach((target) => {
        const defaultClasses = splitClasses(
            target.getAttribute("data-toggler-reset-default"),
        );
        const openClasses = splitClasses(
            target.getAttribute("data-toggler-reset-open"),
        );

        if (openClasses.length) {
            target.classList.remove(...openClasses);
        }
        if (defaultClasses.length) {
            target.classList.add(...defaultClasses);
        }

        if (target.id) {
            document
                .querySelectorAll(`[data-toggler="${target.id}"]`)
                .forEach((btn) => btn.setAttribute("aria-expanded", "false"));
        }
    });
}

function toggleContent() {
    const outsideClickButtons = Array.from(toggleBtns).filter((btn) =>
        btn.hasAttribute("data-toggler-close-outside"),
    );
    const mediaQueryMap = new Map();

    if (toggleBtns) {
        toggleBtns.forEach((e) => {
            e.addEventListener("click", function (e) {
                const toggleBtn = e.currentTarget;
                const id = toggleBtn.dataset.toggler;
                const overlay = toggleBtn.hasAttribute("data-toggler-o");
                const resetSelector = toggleBtn.getAttribute("data-toggler-reset");
                let btnCls = toggleBtn.getAttribute("data-toggler-btn-cls");
                let altToggleBtns;
                let overlayClasses = toggleBtn.getAttribute("data-toggler-o");
                let classes = toggleBtn.getAttribute("data-toggler-cls");
                let toggleElement;
                if (id === "") {
                    toggleElement = toggleBtn.nextElementSibling;
                } else {
                    altToggleBtns = document.querySelectorAll(
                        '[data-toggler="' + id + '"]',
                    );
                    toggleElement = document.getElementById(id);
                }

                if (toggleElement) {
                    if (altToggleBtns && altToggleBtns.length > 1) {
                        [...altToggleBtns].forEach((btn) => {
                            const expanded =
                                btn.getAttribute("aria-expanded") === "true";
                            btn.setAttribute(
                                "aria-expanded",
                                (!expanded).toString(),
                            );
                            if (btnCls)
                                btn.classList.remove(...btnCls.split(" "));
                        });
                    } else {
                        const expanded =
                            toggleBtn.getAttribute("aria-expanded") === "true";
                        toggleBtn.setAttribute(
                            "aria-expanded",
                            (!expanded).toString(),
                        );
                        if (btnCls) {
                            btnCls = btnCls.split(" ");
                            btnCls.map((cl) => toggleBtn.classList.toggle(cl));
                        }
                    }
                    if (overlay) {
                        if (overlayClasses) {
                            overlayClasses = overlayClasses.split(" ");
                            overlayClasses.map((cl) =>
                                document.body.classList.toggle(cl),
                            );
                        } else {
                            document.body.classList.toggle("body-overlay");
                        }
                    }
                    if (classes) {
                        classes = classes.split(" ");
                        classes.map((cl) => toggleElement.classList.toggle(cl));
                    } else {
                        toggleElement.classList.toggle("hidden");
                    }
                    if (resetSelector && toggleBtn.getAttribute("aria-expanded") === "false") {
                        resetToggleTargets(toggleElement, resetSelector);
                    }
                } else {
                    console.error("toggler.js: No element found to toggle.");
                }
            });
        });

        if (outsideClickButtons.length) {
            document.addEventListener("click", (event) => {
                outsideClickButtons.forEach((btn) => {
                    if (btn.getAttribute("aria-expanded") !== "true") {
                        return;
                    }

                    const toggleElement = getToggleElement(btn);
                    if (!toggleElement) {
                        return;
                    }

                    const clickedInsideButton = btn.contains(event.target);
                    const clickedInsideTarget = toggleElement.contains(event.target);

                    if (!clickedInsideButton && !clickedInsideTarget) {
                        resetSingleToggle(btn);
                    }
                });
            });
        }

        Array.from(toggleBtns).forEach((btn) => {
            const mediaQuery = btn.getAttribute("data-toggler-reset-media");
            if (!mediaQuery) {
                return;
            }

            if (!mediaQueryMap.has(mediaQuery)) {
                const mql = window.matchMedia(mediaQuery);
                mediaQueryMap.set(mediaQuery, mql);

                mql.addEventListener("change", () => {
                    Array.from(toggleBtns)
                        .filter(
                            (toggleBtn) =>
                                toggleBtn.getAttribute("data-toggler-reset-media") === mediaQuery,
                        )
                        .forEach((toggleBtn) => {
                            if (toggleBtn.getAttribute("aria-expanded") === "true") {
                                resetSingleToggle(toggleBtn);
                            }
                        });
                });
            }
        });
    }
}

export { toggleContent };
